import { render, staticRenderFns } from "./FiltroAtivoInativo.vue?vue&type=template&id=6b85939a"
import script from "./FiltroAtivoInativo.vue?vue&type=script&lang=js"
export * from "./FiltroAtivoInativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports